// Export the DataPoint type
export { type DataPoint } from "./chart-library/chart-props";
export { Chart } from "./chart-library/Chart";

// Export components
export { WidgetForm } from "./components/WidgetForm";
export { DashboardWidgetTable } from "./components/WidgetTable";
export { DashboardWidget } from "./components/DashboardWidget";

// Export types and utilities
export { type WidgetChartConfig } from "./utils";
